import React, { useState } from 'react';
import { Button, Dialog } from '@mui/material';
import { entityNameMinimumLength, validateEntityName } from 'const/regex';
import { FormFieldInterface } from 'components/Form/Form.types';
import Form from 'components/Form/Form';
import { CreateTagInterface, useTagsContext } from 'pages/Tags/tags.context';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';

const defaultTag: CreateTagInterface = {
  name: '',
  displayColour: '#000000',
};

const CreateTag = () => {
  const [show, setShow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { addTag } = useTagsContext();
  const [newTag, setNewTag] = useState<CreateTagInterface>(defaultTag);
  const { ability } = useAuthContext();

  // Return null if user does not have 'Create' permissions
  if (!hasPermissions(ability, 'create', 'Tag')) {
    return null;
  }

  const handleAddTag = async () => {
    setLoading(true);
    await addTag({ name: newTag.name, displayColour: newTag.displayColour });
    setNewTag(defaultTag);
    setShow(false);
    setLoading(false);
  };

  const handleUpdateField = (value: string, key: keyof CreateTagInterface) =>
    setNewTag({ ...newTag, [key]: value });

  const fields: FormFieldInterface[] = [
    {
      label: 'Tag Name',
      value: newTag.name,
      onChange: (name) => setNewTag({ ...newTag, name }),
      fullWidth: true,
      validator: validateEntityName,
      requiredMinimumLength: entityNameMinimumLength,
    },
    {
      label: 'Display Colour',
      value: newTag.displayColour,
      type: 'color',
      onChange: (val) => handleUpdateField(val, 'displayColour'),
      fullWidth: true,
    },
  ];

  return (
    <>
      <Button onClick={() => setShow(true)}>New Tag</Button>
      <Dialog open={show} onClose={() => setShow(false)}>
        <Form
          fields={fields}
          title='New Tag'
          onSubmit={handleAddTag}
          submitting={loading}
          buttonText='Create Tag'
        />
      </Dialog>
    </>
  );
};

export default CreateTag;
